import type { SVGProps } from 'react';

const SvgDevelopersAlt = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 14" {...props}>
    <path
      fill={props.color}
      d="M9.082.285 5.63 13.165l1.288.344L10.369.63zM10.862 3.092c.26-.26.683-.26.943 0l3.333 3.334c.26.26.26.682 0 .943l-3.333 3.333a.667.667 0 0 1-.943-.943l2.862-2.862-2.862-2.862a.667.667 0 0 1 0-.943M5.138 3.092a.667.667 0 0 0-.942 0L.862 6.426a.667.667 0 0 0 0 .943l3.334 3.333a.667.667 0 0 0 .942-.943L2.276 6.897l2.862-2.862a.667.667 0 0 0 0-.943"
    />
  </svg>
);

export default SvgDevelopersAlt;
